

exports.__esModule = true;

var _util = require('./util');

Object.defineProperty(exports, '$ReturnToMerchant', {
  enumerable: true,
  get: function get() {
    return _util.$ReturnToMerchant;
  }
});

var _formatReturnContent = require('./formatReturnContent');

Object.defineProperty(exports, 'formatReturnContent', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.formatReturnContent;
  }
});
Object.defineProperty(exports, 'MAX_MERCHANT_NAME_LENGTH', {
  enumerable: true,
  get: function get() {
    return _formatReturnContent.MAX_MERCHANT_NAME_LENGTH;
  }
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-return-to-merchant/dist/index.js
// module id = ./components/xo-return-to-merchant/dist/index.js
// module chunks = 1